import { useAuth } from 'context/AuthContext';
import { useEffect, useRef, useState } from 'react';
import InputMask from 'react-input-mask';

import { getQuestionsPublic, sendQuestionsQuizPublic, verifyPlayerPublic } from 'services/quiz.service';

import Button from 'components/ui/button';
import Logo from 'assets/img/new-logo.svg';

import './styles.scss';

export function Votacao() {
  const [quest, setQuest] = useState<any>();
  const [step, setStep] = useState(4);
  const [searching, setSearching] = useState(false);
  const [message, setMessage] = useState('');
  const [search, setSearch] = useState('');

  const { user } = useAuth();

  // useEffect(() => {
  //   async function load() {
  //     const data = await getQuestionsPublic();
  //     setQuest(data[0]);
  //   }

  //   load();
  // }, []);

  // useEffect(() => {
  //   if (user?._id) setSearch(user?._id);
  // }, [user]);

  function removeUnderlines(input: string): string {
    return input.replace(/_/g, '');
  }

  async function handleVote(answer: string) {
    setStep(3);

    await sendQuestionsQuizPublic(search, answer, quest?._id);
  }

  async function handleVerify(e?: any) {
    if (e) {
      e.preventDefault();
    }

    setMessage('');
    setSearching(true);

    const data: any = await verifyPlayerPublic(search);
    setSearching(false);

    if (data?.active && data?.answered) {
      setStep(3);
    } else if (data?.active && !data?.answered) {
      setStep(2);
    } else if (!data || !data?.active) {
      setMessage('Matrícula não encontrada.');
    }
  }

  if (step === 1)
    return (
      <div className="px-4 lg:px-0 flex flex-col h-screen">
        <div className="h-fit mt-auto mb-auto flex flex-col items-center space-y-10 py-10">
          <div className="w-44 lg:w-80">
            <img src={Logo} alt="#JogaJunto BB" className="relative" />
          </div>

          <p className="text-lg lg:text-4xl text-center font-thin lg:leading-relaxed">
            Ei, você! <b className="text-yellow">Preparado para uma missão especial?</b>
            <br className="hidden lg:block" />
            Chegou a hora de escolher a <b className="text-yellow">nova logo Joga Junto</b> e <br className="hidden lg:block" />{' '}
            contamos com a sua ajuda para essa decisão épica.
          </p>

          <form onSubmit={handleVerify} className="w-full lg:w-[400px] px-2 flex flex-col space-y-2">
            <InputMask
              placeholder="Digite a sua matrícula"
              alwaysShowMask={false}
              mask={'F9999999'}
              value={search}
              onChange={e => setSearch(e.target.value)}
              style={{ fontSize: 16 }}
              className="w-full mx-auto bg-maastricht-blue text-white text-sm font-light flex-1 rounded-md py-4 px-4"
            />

            {searching && (
              <div className="flex-1 bg-rich-black bg-opacity-80 p-4 rounded-3xl text-center">
                <p className="animate-pulse text-yellow">Recuperando informações...</p>
              </div>
            )}

            {message && (
              <div className="flex-1 bg-rich-black bg-opacity-80 p-4 rounded-3xl text-center">
                <p className=" text-yellow">{message}</p>
              </div>
            )}

            <Button
              className="uppercase disabled:opacity-50 py-2 px-5 rounded w-fit mx-auto"
              disabled={searching || removeUnderlines(search).length < 8}
            >
              Continuar
            </Button>
          </form>
        </div>
      </div>
    );

  if (step === 2)
    return (
      <div className="px-4 lg:px-0 container mx-auto flex flex-col space-y-2 pt-10 lg:pt-0  h-screen">
        <div className="flex flex-col my-auto py-3 lg:py-10">
          <p className="text-lg lg:text-4xl text-center lg:text-left">Escolha a sua opção favorita</p>
          <div className="pt-5 grid gap-y-5 lg:grid-cols-3 pb-10 lg:pb-0">
            {quest?.choices?.map((item: any) => (
              <div className="flex flex-col items-center space-y-4">
                <img className="h-[150px] lg:h-[300px]" src={item.extra.img} alt="" />

                <p className="relative px-4 py-2 rounded-md border-gradient-custom">{item.label}</p>

                <button
                  onClick={() => handleVote(item.answer)}
                  className="px-3 py-2 w-fit lg:w-[18%] bg-yellow text-oxford-blue font-bold rounded-xl text-lg"
                >
                  VOTAR
                </button>
              </div>
            ))}
          </div>
        </div>
      </div>
    );

  if (step === 3)
    return (
      <div className="px-4 lg:px-0 flex flex-col h-screen">
        <div className="h-fit mt-auto mb-auto flex flex-col items-center space-y-10 py-10">
          <div className="w-44 lg:w-80">
            <img src={Logo} alt="#JogaJunto BB" className="relative" />
          </div>

          <p className="text-lg lg:text-4xl text-center font-thin lg:leading-relaxed">
            Agradecemos por mais uma vez jogar junto com a gente! <br className="hidden lg:block" /> Sua participação é essencial
            para que o nosso jogo aconteça. <br className="hidden lg:block" />
            <b className="text-yellow"> Até a próxima aventura!</b>
          </p>
        </div>
      </div>
    );

  if (step === 4)
    return (
      <div className="px-4 lg:px-0 flex flex-col h-screen">
        <div className="h-fit mt-auto mb-auto flex flex-col items-center space-y-10 py-10">
          <div className="w-44 lg:w-80">
            <img src={Logo} alt="#JogaJunto BB" className="relative" />
          </div>

          <p className="text-lg lg:text-4xl text-center font-thin lg:leading-relaxed text-yellow">Votação encerrada!</p>

          <p className="text-lg lg:text-4xl text-center font-thin lg:leading-relaxed">
            Agradecemos por mais uma vez jogar junto com a gente! <br className="hidden lg:block" /> Sua participação é essencial
            para que o nosso jogo aconteça. <br className="hidden lg:block" />
            <b className="text-yellow"> Até a próxima aventura!</b>
          </p>
        </div>
      </div>
    );

  return (
    <div className="p-10">
      <p>Carregando...</p>
    </div>
  );
}
